module.exports = __webpack_public_path__ + "img/bg_repeat_a.b36f3cb1.png";